module.exports = __webpack_public_path__ + "img/bi.e2349f70.svg";